
import { ElMessage } from "element-plus";
import { getEnum, login } from "@/api/index";

import { useStore } from "vuex";
import { ElForm } from "element-plus";

import { putDepart } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增部门",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  emits: ["close"],
  setup(opt, contex) {
    const ruleFormRef = ref(ElForm);
    let isEdit = false;
    let show = opt.open;
    const store = useStore();

    const dataMap: any = reactive({
      ruleForm: {
        title: "",
        description: "",
        idx: "",
      },
      rules: {
        title: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
      },

      async putNewData() {
        const res = await putDepart(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
    }

    const submitForm = () => {
      const form = unref(ruleFormRef);
      form.validate((valid: any) => {
        if (valid) {
          dataMap.putNewData();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const close = () => {
      const form = unref(ruleFormRef);

      // form.resetFields();
      console.log(dataMap.ruleForm);
      contex.emit("close", false);
    };

    return {
      show,
      store,
      isEdit,
      ruleFormRef,
      submitForm,
      close,
      ...toRefs(dataMap),
    };
  },
});
